export const GET_AVAILABLE_CHAPTERS =
  'personalizedStudy/GET_AVAILABLE_CHAPTERS';
export const SET_AVAILABLE_CHAPTERS =
  'personalizedStudy/SET_AVAILABLE_CHAPTERS';
export const SET_AVAILABLE_CHAPTERS_LOADING =
  'personalizedStudy/SET_AVAILABLE_CHAPTERS_LOADING';

export const SAVE_SELECTED_CHAPTERS =
  'personalizedStudy/SAVE_SELECTED_CHAPTERS';
export const SET_SAVE_CHAPTERS_LOADING =
  'personalizedStudy/SET_SAVE_CHAPTERS_LOADING';

export const BUILD_CHAPTER_STUDY_PLAN =
  'personalizedStudy/BUILD_CHAPTER_STUDY_PLAN';
export const SET_BUILD_CHAPTER_STUDY_PLAN_LOADING =
  'personalizedStudy/SET_BUILD_CHAPTER_STUDY_PLAN_LOADING';

export const LOAD_CHAPTER_STUDY_PLAN =
  'personalizedStudy/LOAD_CHAPTER_STUDY_PLAN';
export const SET_CHAPTER_STUDY_PLAN =
  'personalizedStudy/SET_CHAPTER_STUDY_PLAN';
